module.exports = __FOREMAN_VENDOR__REACT_ROUTER_DOM__;